import React from 'react';

// Lion logo — removes the image's white background using CSS blend modes.
// - On light header (variant='gold') use `multiply` so white pixels vanish
//   against the cream nav background.
// - On dark footer (variant='dark') use `screen` on an inverted image so the
//   white background disappears against the dark footer.
export default function LionLogo({ size = 52, variant = 'gold' }) {
  const isDark = variant === 'dark';
  return (
    <img
      src="https://customer-assets-m6fa6gv7.emergentagent.net/job_etawah-lion-safari/artifacts/gpv8h8i6_image.png"
      alt="Etawah Lion Safari"
      style={{
        height: size,
        width: 'auto',
        objectFit: 'contain',
        flexShrink: 0,
        mixBlendMode: isDark ? 'screen' : 'multiply',
        filter: isDark ? 'invert(1) hue-rotate(180deg)' : 'none',
      }}
    />
  );
}
